import React from "react";
import { ContactReferenceModel } from "../models";
import { CustomLabel, FlexContainer } from "@mindmemobile/mm-shared-global";

type Props = {
  contact: ContactReferenceModel;
};

const RenderContactInfo: React.FC<Props> = ({ contact }) => {
  const hasFullName = Boolean(contact?.fullName);

  const secondaryTextStyles = {
    fontSize: hasFullName ? "12px" : "16px",
    lineHeight: hasFullName ? "16px" : "22px",
    fontWeight: hasFullName ? "400" : "600",
  };

  const phoneNumber =
    contact?.homePhone?.phoneNumber ||
    contact?.mobilePhone?.phoneNumber ||
    contact?.workPhone?.phoneNumber ||
    contact?.otherPhone?.phoneNumber ||
    "";

  return (
    <FlexContainer fxLayout="column" spacing={3}>
      {contact?.fullName && (
        <CustomLabel fontSize="16px" fontWeight={600}>
          {contact?.fullName}
        </CustomLabel>
      )}

      {contact?.email && (
        <CustomLabel {...secondaryTextStyles}>{contact.email}</CustomLabel>
      )}

      {phoneNumber && (
        <CustomLabel {...secondaryTextStyles}>{phoneNumber}</CustomLabel>
      )}
    </FlexContainer>
  );
};

export default RenderContactInfo;
